/*
 * Copyright (c) 2015 - 2023 by KAA Soft. All rights reserved.
 */

import { adminConfig } from "../adminConfig";
import { handleFormData } from "./form";
import { httpRequest } from "./httpRequest";
import { lazyLoadInit } from "./lazyLoad";
import { loadingElement } from "./utils/loadingElement";
import { getOffsetTop, scrollTo } from "./utils/functions";
import { popup } from "./popup";
function getFilterFormParams(filterForm) {
  if (filterForm instanceof HTMLElement && filterForm.tagName.toLowerCase() === "form") {
    var formDataArray = handleFormData(filterForm);
    // Sort Column & Order
    var sortEl = filterForm.querySelector('.filter-list-sort');
    if (sortEl) {
      var sortOrder = sortEl.options[sortEl.selectedIndex].dataset.order;
      formDataArray.push(['sortOrder', sortOrder ? sortOrder : "DESC"]);
    }
    var params = new URLSearchParams(formDataArray);
    return params.toString();
  }
  return null;
}
export function updateList(_ref) {
  var containerId = _ref.containerId,
    filterFormId = _ref.filterFormId,
    routeURL = _ref.routeURL,
    _ref$isJSON = _ref.isJSON,
    isJSON = _ref$isJSON === void 0 ? false : _ref$isJSON,
    jsonHandler = _ref.jsonHandler;
  // todo: remove it
  if (!containerId) return console.warn(adminConfig.messages.containerIdNotSpecified);
  var container = document.getElementById(containerId);
  if (!container) return console.warn(adminConfig.messages.containerNotExist);
  var additionalGetParams = container.dataset.params ? container.dataset.params : '';
  var changeURLState = container.dataset.changeUrlState ? container.dataset.changeUrlState === 'true' : true;
  var filterForm = filterFormId ? document.getElementById(filterFormId) : document.getElementById(container.dataset.filterForm);
  var route = routeURL ? routeURL : container.dataset.route;
  var filterData = filterForm ? filterForm : null;
  if (!route) return console.warn(adminConfig.messages.routeNotSpecified);
  if (filterFormId && filterForm && !adminConfig.forms[filterFormId].validate()) return;
  loadingElement.start('#' + containerId);
  filterForm ? loadingElement.start('#' + filterFormId) : false;
  httpRequest({
    url: route + additionalGetParams,
    data: filterForm ? getFilterFormParams(filterData) : null
  }).then(function (response) {
    var _response$data;
    if (!(response != null && (_response$data = response.data) != null && _response$data.error)) {
      if (!isJSON) {
        container.innerHTML = response.data.html;
        lazyLoadInit();
      } else {
        if (typeof adminConfig.handlersFn[jsonHandler] === 'function') {
          adminConfig.handlersFn[jsonHandler](response.data);
        }
      }
      scrollTo(getOffsetTop(document.querySelector('#' + containerId) + 100), 300);
      if (changeURLState) {
        history.pushState(null, '', route);
      }
    }
  })["finally"](function () {
    loadingElement.finish('#' + containerId);
    filterForm ? loadingElement.finish('#' + filterFormId) : false;
  });
}
export function filterElementsInit(containerSelector) {
  if (containerSelector === void 0) {
    containerSelector = 'body';
  }
  var container = document.querySelector(containerSelector);
  function processFilterElement(element) {
    if (!element instanceof HTMLElement) return;
    var form = element.closest('form');
    if (!form) return console.warn(adminConfig.messages.formNotExist);
    var filterFormId = form.id;
    var containerId = form.dataset.container;
    if (containerId) updateList({
      containerId: containerId,
      filterFormId: filterFormId
    });
  }
  var filterElements = container.querySelectorAll('.filter-element:not(.filter-custom-select)');
  for (var i = 0; i < filterElements.length; i++) {
    filterElements[i].addEventListener("change", function (e) {
      processFilterElement(e.target);
    });
  }
}
export function updateHTML(containerId, html) {
  if (!containerId) return console.warn(adminConfig.messages.containerIdNotSpecified);
  var container = document.getElementById(containerId);
  if (!container) return console.warn(adminConfig.messages.containerNotExist);
  container.innerHTML = html;
}
export function listsInit() {
  document.addEventListener("click", function (e) {
    if (!e.target.matches(".ajax-pagination")) return;
    e.preventDefault();
    var containerId = e.target.dataset.container;
    var route = e.target.href;
    var isJSON = e.target.dataset.json === 'true';
    var jsonHandler = e.target.dataset.jsonHandler ? e.target.dataset.jsonHandler : null;

    // console.info('isJSON', isJSON)
    // console.info('jsonHandler', jsonHandler)

    updateList({
      containerId: containerId,
      routeURL: route,
      isJSON: isJSON,
      jsonHandler: jsonHandler
    });
  });
  document.addEventListener("click", function (e) {
    if (!e.target.matches(".remove-list-item")) return;
    var elementId = e.target.dataset.element;
    if (elementId) {
      var element = document.getElementById(elementId);
      if (element) element.remove();
    } else {
      var containerId = e.target.dataset.container;
      if (!containerId) return console.warn(adminConfig.messages.containerIdNotSpecified);
      var route = e.target.dataset.route;
      if (!route) return console.warn(adminConfig.messages.routeNotSpecified);
      popup({
        popupId: 'remove',
        route: route,
        confirm: function confirm() {
          updateList({
            containerId: containerId
          });
        }
      });
    }
  });
}

/**
 * @property {boolean} pages.isCurrent
 * @property {boolean} pages.isFirst
 * @property {boolean} pages.isLast
 * @property {boolean} pages.isNext
 * @property {boolean} pages.isPrevious
 * @property {string} pages.title
 * @param pages {array} Pagination pages
 * @param containerId {string} Container to append pagination
 * @param handlerFnName {string} Function how process list after request
 * @param changeURLState {boolean} Change URL State after request
 * @returns {string} Pagination template
 */
export function getPaginationTemplate(pages, containerId, handlerFnName, changeURLState) {
  if (changeURLState === void 0) {
    changeURLState = false;
  }
  if (!pages || pages.length === 0 || !containerId) return '';
  var pageLinksMarkup = '';
  for (var i = 0; i < pages.length; i++) {
    var page = pages[i];
    var linkContent = '';
    if (page.isFirst) {
      linkContent = i18n.gettext('First Page');
    } else if (page.isLast) {
      linkContent = i18n.gettext('Last Page');
    } else if (page.isNext) {
      linkContent = '<span class="d-none d-sm-inline pe-none">' + i18n.gettext('Next Page') + '</span>';
    } else if (page.isPrevious) {
      linkContent = '<span class="d-none d-sm-inline pe-none">' + i18n.gettext('Previous Page') + '</span>';
    } else {
      linkContent = page.title;
    }
    var link = '<li class="page-item' + (page.isCurrent ? ' active' : '') + '"><a href="' + page.link + '" class="page-link ajax-pagination" data-json="true" data-json-handler="' + handlerFnName + '" data-change-url-state="' + changeURLState + '" data-container="' + containerId + '">' + linkContent + '</a></li>';
    pageLinksMarkup += link;
  }
  return '<nav aria-label="Page navigation" class="mt-3 mb-2"><ul class="pagination pagination-space justify-content-center" aria-label="Page navigation">' + pageLinksMarkup + '</ul></nav>';
}